import { render, staticRenderFns } from "./FilterRegion.vue?vue&type=template&id=c85bf5fc&"
import script from "./FilterRegion.vue?vue&type=script&lang=js&"
export * from "./FilterRegion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports